module.exports = __webpack_public_path__ + "img/cc-visa.3763fafd.svg";